import React from "react"

import SelectTags from "../../../common/tags/SelectTags"

const sub_types = [
    { label: "Sub community", value: "sub_community" },
    { label: "Sub group", value: "sub_group" }
]

const CommunityEditHierarchy = ({
    reference,
    parent,
    subGroups,
    subCommunities,
    subType,
    onCommunitiesSearch,
    onEventChange,
    onValueChange
}) => (
    <div className="widget">
        <div className="widget-content">
            {reference && [
                <h3 key="reference-header" className="first-heading">
                    <span className="icon icon-concepts" />
                    Derived From {reference.label}
                </h3>,
                <div key={reference.name} className="tags clearfix">
                    <div className="tag-item grey">{reference.name}</div>
                </div>
            ]}
            <h3 className={!reference ? "first-heading" : ""}>
                <span className="icon icon-community" />
                Parent community
            </h3>
            <div>
                <SelectTags
                    name="parent"
                    value={parent}
                    loadOptions={onCommunitiesSearch}
                    placeholder="Parent community"
                    onChange={onValueChange("parent")}
                />
            </div>
            {parent && (
                <div>
                    <h3>
                        <span className="icon icon-status" />Sub type
                    </h3>
                    {sub_types.map(({ label, value, isDefault }) => (
                        <div className="radio" key={value}>
                            <label>
                                <input
                                    type="radio"
                                    name="sub_type"
                                    value={value}
                                    checked={subType === value}
                                    onChange={onEventChange}
                                />
                                {label}
                            </label>
                        </div>
                    ))}
                </div>
            )}
            <h3>
                <span className="icon icon-community" />Sub-communities
            </h3>
            <div>
                <SelectTags
                    name="sub-communities"
                    value={subCommunities}
                    loadOptions={onCommunitiesSearch}
                    placeholder="Sub-communities"
                    onChange={onValueChange("sub_communities")}
                />
            </div>
            <h3>
                <span className="icon icon-community" />Sub-groups
            </h3>
            <div>
                <SelectTags
                    name="sub_groups"
                    value={subGroups}
                    loadOptions={onCommunitiesSearch}
                    placeholder="Sub-groups"
                    onChange={onValueChange("sub_groups")}
                />
            </div>
        </div>
    </div>
)

export default CommunityEditHierarchy
